import { Box } from '@squareup/dex-ui-shared-base';
import { TrackedBox } from '@squareup/dex-ui-user-interaction-publisher';
import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';

import styles from './content-layout.module.css';

interface Props {
  requestContent: ReactNode;
  responseContent: ReactNode;
}

const ApiExplorerRequestResponseAsideLayout: FC<Props> = ({
  requestContent,
  responseContent,
}) => {
  return (
    <Box className={clsx(styles['floating-block'])}>
      <TrackedBox
        trackingId="request"
        className={clsx(styles['code-block'])}
        margin={{ bottom: '2x' }}
      >
        {requestContent}
      </TrackedBox>
      <Box className={clsx(styles['code-block'], styles.response)}>
        {responseContent}
      </Box>
    </Box>
  );
};

export { ApiExplorerRequestResponseAsideLayout };
